/* ==========================================================================
   SCUFFERS — coeur du thème (vanilla, sans dépendance)
   ========================================================================== */
(function () {
  'use strict';

  var R = window.scfRoutes || {};
  var T = window.scfTextes || {};
  var estEditeur = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- utilitaires ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }
  function fmt(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0' + (window.scfDevise || 'EUR');
  }
  function debounce(fn, d) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, d); };
  }

  /* ---------- verrou de défilement (iOS compatible) ---------- */
  var posY = 0, verrous = 0;
  function verrouiller() {
    if (verrous++ > 0) return;
    posY = window.scrollY;
    document.body.style.top = -posY + 'px';
    document.body.classList.add('scf-fige');
  }
  function deverrouiller() {
    if (--verrous > 0) return;
    verrous = 0;
    document.body.classList.remove('scf-fige');
    document.body.style.top = '';
    /* La racine porte scroll-behavior:smooth : sans neutralisation, la
       restauration de position s'anime et la page défile visiblement du
       haut vers le bas à chaque fermeture de panneau. */
    var lisse = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, posY);
    document.documentElement.style.scrollBehavior = lisse;
    /* Le défilement était figé : aucun événement scroll n'a été émis
       pendant l'ouverture. On redemande une évaluation de l'en-tête,
       sinon il garde l'état qu'il avait avant. */
    window.dispatchEvent(new Event('scroll'));
  }

  /* ---------- panneaux coulissants ---------- */
  var Panneaux = {
    ouverts: [],
    ouvrir: function (el) {
      if (!el || el.classList.contains('est-ouvert')) return;
      el.classList.add('est-ouvert');
      el.setAttribute('aria-hidden', 'false');
      verrouiller();
      Panneaux.ouverts.push(el);
      document.body.classList.add('scf-panneau-ouvert');
      var f = el.querySelector('[data-focus-initial]') || el.querySelector('button,a,input');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
    },
    fermer: function (el) {
      if (!el || !el.classList.contains('est-ouvert')) return;
      el.classList.remove('est-ouvert');
      el.setAttribute('aria-hidden', 'true');
      deverrouiller();
      Panneaux.ouverts = Panneaux.ouverts.filter(function (x) { return x !== el; });
      if (!Panneaux.ouverts.length) document.body.classList.remove('scf-panneau-ouvert');
      var d = el.getAttribute('data-declencheur');
      if (d) { var b = document.getElementById(d); if (b) b.focus({ preventScroll: true }); }
    },
    basculer: function (el) {
      if (!el) return;
      el.classList.contains('est-ouvert') ? Panneaux.fermer(el) : Panneaux.ouvrir(el);
    },
    toutFermer: function () { Panneaux.ouverts.slice().forEach(Panneaux.fermer); }
  };
  window.scfPanneaux = Panneaux;

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ouvrir]');
    if (o) {
      e.preventDefault();
      var c = document.getElementById(o.getAttribute('data-ouvrir'));
      if (c) { if (o.id) c.setAttribute('data-declencheur', o.id); Panneaux.ouvrir(c); }
      return;
    }
    var f = e.target.closest('[data-fermer]');
    if (f) {
      e.preventDefault();
      var p = f.getAttribute('data-fermer') ? document.getElementById(f.getAttribute('data-fermer')) : f.closest('.scf-tiroir,.scf-modale,.scf-recherche');
      Panneaux.fermer(p);
      return;
    }
    if (e.target.classList && (e.target.classList.contains('scf-tiroir__voile') || e.target.classList.contains('scf-modale__voile') || e.target.classList.contains('scf-recherche__voile'))) {
      Panneaux.fermer(e.target.closest('.scf-tiroir,.scf-modale,.scf-recherche'));
    }
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape' && Panneaux.ouverts.length) {
      Panneaux.fermer(Panneaux.ouverts[Panneaux.ouverts.length - 1]);
    }
  });

  /* ---------- déplacement des panneaux hors du header ---------- */
  function extraire() {
    $$('[data-extraire]').forEach(function (el) {
      if (el.parentNode !== document.body) document.body.appendChild(el);
    });
  }

  /* ---------- onglets du tiroir de navigation ---------- */
  function initOnglets(portee) {
    $$('[data-onglets]', portee).forEach(function (grp) {
      var boutons = $$('[role=tab]', grp);
      boutons.forEach(function (b) {
        on(b, 'click', function () {
          var cible = b.getAttribute('aria-controls');
          boutons.forEach(function (x) {
            var sel = x === b;
            x.setAttribute('aria-selected', sel ? 'true' : 'false');
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !sel;
          });
          var pane = document.getElementById(cible);
          if (pane) pane.hidden = false;
        });
      });
    });
  }

  /* ---------- en-tête transparent sur héros ---------- */
  function initEntete() {
    var h = $('.scf-entete');
    if (!h) return;
    var wrap = h.closest('.scf-section-entete') || h.parentNode;
    var hero = $('.scf-hero-transparent');

    document.body.classList.toggle('scf-a-hero', !!hero);

    /* La valeur mesurée part dans --scf-entete-h, que rien à l'intérieur de
       l'en-tête ne relit. Le gabarit de la barre vit dans --scf-entete-barre-h,
       constante. Sans cette séparation, la bordure de 1px s'ajoutait à chaque
       passage et le ResizeObserver faisait croître l'en-tête indéfiniment. */
    var derniere = -1;
    var maj = function () {
      var h = Math.round(wrap.getBoundingClientRect().height);
      if (h === derniere || h === 0) return;
      derniere = h;
      document.documentElement.style.setProperty('--scf-entete-h', h + 'px');
    };
    maj();
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (window.requestAnimationFrame) window.requestAnimationFrame(maj);
        else maj();
      }).observe(wrap);
    }

    if (!h.classList.contains('scf-entete--transparent')) return;

    /* L'en-tête est transparent tant qu'une section à fond sombre passe
       derrière lui, pas seulement le héros : le menu défilant, le lookbook
       et tout bloc marqué data-scf-media-sombre comptent aussi. On teste ce
       qui se trouve réellement sous la barre plutôt qu'un seuil fixe. */
    var sombres = $$('.scf-hero-transparent, [data-scf-media-sombre]');
    if (!sombres.length) { h.classList.add('est-opaque'); return; }
    document.body.classList.add('scf-a-hero');

    var attente = false;
    var onScroll = function () {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () {
        attente = false;
        var ligne = wrap.getBoundingClientRect().height * 0.6;
        var dessus = false;
        for (var i = 0; i < sombres.length; i++) {
          var r = sombres[i].getBoundingClientRect();
          if (r.top <= ligne && r.bottom >= ligne) { dessus = true; break; }
        }
        h.classList.toggle('est-opaque', !dessus);
      });
    };
    onScroll();
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', debounce(onScroll, 120));
  }

  /* ---------- galeries à défilement (points de progression) ---------- */
  function initGaleries(portee) {
    $$('[data-galerie]', portee).forEach(function (g) {
      var piste = $('[data-galerie-piste]', g);
      var points = $$('[data-galerie-point]', g);
      if (!piste || !points.length) return;
      var maj = debounce(function () {
        var i = Math.round(piste.scrollLeft / Math.max(piste.clientWidth, 1));
        points.forEach(function (p, n) { p.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }, 60);
      on(piste, 'scroll', maj, { passive: true });
      points.forEach(function (p, n) {
        on(p, 'click', function () { piste.scrollTo({ left: piste.clientWidth * n, behavior: 'smooth' }); });
      });
      maj();
    });
  }

  /* ---------- rails avec flèches ---------- */
  function initRails(portee) {
    $$('[data-rail]', portee).forEach(function (bloc) {
      var rail = $('[data-rail-piste]', bloc);
      var prev = $('[data-rail-prev]', bloc);
      var next = $('[data-rail-next]', bloc);
      if (!rail) return;
      var pas = function () { return rail.clientWidth * 0.8; };
      on(prev, 'click', function () { rail.scrollBy({ left: -pas(), behavior: 'smooth' }); });
      on(next, 'click', function () { rail.scrollBy({ left: pas(), behavior: 'smooth' }); });
      var maj = debounce(function () {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
        var inutile = rail.scrollWidth <= rail.clientWidth + 2;
        if (prev) prev.hidden = inutile;
        if (next) next.hidden = inutile;
      }, 60);
      on(rail, 'scroll', maj, { passive: true });
      on(window, 'resize', maj);
      maj();
    });
  }

  /* ---------- panier ---------- */
  var Panier = {
    etat: null,
    recuperer: function () {
      return fetch(R.cart || '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { Panier.etat = d; Panier.majPastille(d); return d; });
    },
    majPastille: function (d) {
      $$('[data-compte-panier]').forEach(function (el) {
        el.textContent = d.item_count;
        el.setAttribute('data-vide', d.item_count === 0 ? 'true' : 'false');
      });
    },
    ajouter: function (id, qte, props) {
      var corps = { items: [{ id: id, quantity: qte || 1 }] };
      if (props) corps.items[0].properties = props;
      return fetch((R.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps)
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || T.erreurPanier || 'Erreur');
          return d;
        });
      });
    },
    modifier: function (cle, qte) {
      return fetch((R.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: cle, quantity: qte })
      }).then(function (r) { return r.json(); });
    },
    rafraichir: function () {
      var tiroir = $('#scf-panier');
      if (!tiroir) return Panier.recuperer();
      var sid = tiroir.getAttribute('data-section-id');
      return fetch(window.location.pathname + '?section_id=' + sid, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.querySelector('[data-panier-inner]');
          var vieux = $('[data-panier-inner]', tiroir);
          if (neuf && vieux) vieux.innerHTML = neuf.innerHTML;
          return Panier.recuperer();
        })
        .catch(function () { return Panier.recuperer(); });
    },
    ouvrir: function () {
      var t = $('#scf-panier');
      if (t) Panneaux.ouvrir(t);
    }
  };
  window.scfPanier = Panier;

  /* ---------- ajout depuis la carte produit ---------- */
  document.addEventListener('click', function (e) {
    var ouvrir = e.target.closest('[data-ajout-ouvrir]');
    if (ouvrir) {
      e.preventDefault(); e.stopPropagation();
      var b = ouvrir.closest('[data-ajout]');
      $$('[data-ajout].est-ouvert').forEach(function (x) { if (x !== b) x.classList.remove('est-ouvert'); });
      if (b) b.classList.add('est-ouvert');
      return;
    }
    var fermer = e.target.closest('[data-ajout-fermer]');
    if (fermer) {
      e.preventDefault(); e.stopPropagation();
      var bb = fermer.closest('[data-ajout]');
      if (bb) bb.classList.remove('est-ouvert');
      return;
    }
    var taille = e.target.closest('[data-ajout-variante]');
    if (taille) {
      e.preventDefault(); e.stopPropagation();
      var id = taille.getAttribute('data-ajout-variante');
      taille.disabled = true;
      Panier.ajouter(id, 1)
        .then(function () { return Panier.rafraichir(); })
        .then(function () {
          var b2 = taille.closest('[data-ajout]');
          if (b2) b2.classList.remove('est-ouvert');
          Panier.ouvrir();
        })
        .catch(function (err) { alert(err.message); })
        .then(function () { taille.disabled = false; });
      return;
    }
    if (!e.target.closest('[data-ajout]')) {
      $$('[data-ajout].est-ouvert').forEach(function (x) { x.classList.remove('est-ouvert'); });
    }
  });

  /* ---------- lignes du panier ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qte]');
    if (q) {
      e.preventDefault();
      var ligne = q.closest('[data-cle]');
      var champ = $('input', q.parentNode);
      var delta = parseInt(q.getAttribute('data-qte'), 10);
      var val = Math.max(0, parseInt(champ.value, 10) + delta);
      champ.value = val;
      q.disabled = true;
      Panier.modifier(ligne.getAttribute('data-cle'), val)
        .then(function () { return Panier.rafraichir(); })
        .then(function () { q.disabled = false; });
      return;
    }
    var sup = e.target.closest('[data-supprimer]');
    if (sup) {
      e.preventDefault();
      var l = sup.closest('[data-cle]');
      sup.style.pointerEvents = 'none';
      Panier.modifier(l.getAttribute('data-cle'), 0).then(function () { return Panier.rafraichir(); });
    }
  });
  document.addEventListener('change', function (e) {
    var champ = e.target.closest('[data-qte-champ]');
    if (!champ) return;
    var l = champ.closest('[data-cle]');
    Panier.modifier(l.getAttribute('data-cle'), Math.max(0, parseInt(champ.value, 10) || 0))
      .then(function () { return Panier.rafraichir(); });
  });

  /* ---------- formulaire produit ---------- */
  function initFormulaireProduit(portee) {
    $$('[data-form-produit]', portee).forEach(function (form) {
      var donnees;
      try { donnees = JSON.parse($('[data-variantes]', form).textContent); } catch (err) { donnees = []; }
      var champId = $('[data-variante-id]', form);
      var bouton = $('[data-ajouter]', form);
      var libelle = $('[data-libelle-variante]', form);
      var prix = $$('[data-prix-produit]');
      var boutons = $$('[data-option]', form);
      if (!donnees.length) return;

      /* Le bouton d'achat porte deux zones, le libellé et le prix. Poser un
         textContent sur le bouton entier effacerait le prix ; on vise donc
         .scf-btn__libelle quand elle existe, le bouton sinon. */
      function ecrire(btn, texte) {
        if (!btn) return;
        var cible = btn.querySelector('.scf-btn__libelle');
        (cible || btn).textContent = texte;
      }
      function lire(btn) {
        if (!btn) return '';
        var cible = btn.querySelector('.scf-btn__libelle');
        return (cible || btn).textContent;
      }

      function courante() {
        var actif = form.querySelector('[data-option].est-actif');
        if (!actif) return null;
        var val = actif.getAttribute('data-option');
        for (var i = 0; i < donnees.length; i++) {
          if (String(donnees[i].option1) === String(val)) return donnees[i];
        }
        return null;
      }
      function appliquer() {
        var v = courante();
        if (!v) {
          if (bouton) { bouton.disabled = true; ecrire(bouton, T.choisirTaille || 'Choisir une taille'); }
          return;
        }
        if (champId) champId.value = v.id;
        if (libelle) libelle.textContent = v.public_title || v.title;
        if (v.price != null) prix.forEach(function (el) { el.innerHTML = fmt(v.price); });
        if (bouton) {
          bouton.disabled = !v.available;
          ecrire(bouton, v.available ? (T.ajouter || 'Ajouter au panier') : (T.epuise || 'Épuisé'));
        }
        if (window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      boutons.forEach(function (b) {
        on(b, 'click', function () {
          if (b.classList.contains('est-indispo') && b.hasAttribute('data-bloquer')) return;
          boutons.forEach(function (x) { x.classList.remove('est-actif'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('est-actif');
          b.setAttribute('aria-pressed', 'true');
          appliquer();
        });
      });
      if (boutons.length === 1) { boutons[0].classList.add('est-actif'); }
      appliquer();

      on(form, 'submit', function (e) {
        e.preventDefault();
        var v = courante();
        if (!v || !v.available) return;
        bouton.disabled = true;
        var t = lire(bouton);
        ecrire(bouton, T.enCours || 'Ajout…');
        var champQte = $('[data-qte-produit]', form);
        var qte = champQte ? parseInt(champQte.value, 10) || 1 : 1;
        Panier.ajouter(v.id, qte)
          .then(function () { return Panier.rafraichir(); })
          .then(function () { Panier.ouvrir(); })
          .catch(function (err) { alert(err.message); })
          .then(function () { bouton.disabled = false; ecrire(bouton, t); });
      });
    });
  }

  /* ---------- barre d'achat collante ---------- */
  function initBarreAchat() {
    var barre = $('[data-barre-achat]');
    var ancre = $('[data-form-produit]');
    if (!barre || !ancre || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entrees) {
      barre.classList.toggle('est-visible', !entrees[0].isIntersecting);
    }, { rootMargin: '0px 0px -60px 0px' }).observe(ancre);
  }

  /* ---------- recherche prédictive ---------- */
  function initRecherche() {
    var boite = $('#scf-recherche');
    if (!boite) return;
    var champ = $('[data-recherche-champ]', boite);
    var sortie = $('[data-recherche-resultats]', boite);
    if (!champ || !sortie) return;
    var dernier = '';
    var lancer = debounce(function () {
      var q = champ.value.trim();
      if (q === dernier) return;
      dernier = q;
      if (q.length < 2) { sortie.innerHTML = ''; return; }
      var u = (R.predictive || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&section_id=scf-recherche-predictive';
      fetch(u, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var n = doc.querySelector('[data-recherche-resultats]');
          sortie.innerHTML = n ? n.innerHTML : '';
        })
        .catch(function () { sortie.innerHTML = ''; });
    }, 260);
    on(champ, 'input', lancer);
  }

  /* ---------- filtres de collection ---------- */
  function initFiltres() {
    var zone = $('[data-filtres]');
    if (!zone) return;
    function charger(url, pousser) {
      var grille = $('[data-grille-produits]');
      if (grille) grille.style.opacity = '.45';
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-grille-produits]', '[data-filtres]', '[data-compte-produits]', '[data-pagination]'].forEach(function (s) {
            var n = doc.querySelector(s), o = document.querySelector(s);
            if (n && o) o.innerHTML = n.innerHTML;
          });
          if (pousser) window.history.pushState({}, '', url);
          var g = $('[data-grille-produits]');
          if (g) g.style.opacity = '';
          initRails(document); initGaleries(document);
        });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-filtre-lien]');
      if (!a) return;
      e.preventDefault();
      charger(a.href, true);
      var p = a.closest('.scf-tiroir');
      if (p) Panneaux.fermer(p);
    });
    document.addEventListener('change', function (e) {
      var f = e.target.closest('[data-filtre-form]');
      if (!f) return;
      var params = new URLSearchParams(new FormData(f));
      charger(f.getAttribute('action') + '?' + params.toString(), true);
    });
    on(window, 'popstate', function () { charger(window.location.href, false); });
  }

  /* ---------- bascule d'univers ---------- */
  function initBascule(portee) {
    $$('[data-bascule-univers]', portee).forEach(function (sec) {
      var input = $('[data-bascule-input]', sec);
      var principal = $('[data-univers="principal"]', sec);
      var femme = $('[data-univers="femme"]', sec);
      var cp = $('[data-compte-principal]', sec);
      var cf = $('[data-compte-femme]', sec);
      if (!input || !principal || !femme) return;

      /* Les deux grilles sont déjà dans la page : on échange laquelle
         est visible, sans requête ni navigation. */
      on(input, 'change', function () {
        var f = input.checked;
        principal.hidden = f;
        femme.hidden = !f;
        if (cp) cp.hidden = f;
        if (cf) cf.hidden = !f;
      });
    });
  }

  /* ---------- menu défilant sur images ---------- */
  function initDefilant(portee) {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $$('[data-defilant]', portee).forEach(function (sec) {
      var volets = $$('[data-volet]', sec);
      var items = $$('[data-item]', sec);
      var medias = $$('[data-media]', sec);
      var num = $('[data-num]', sec);
      var barre = $('[data-barre]', sec);
      if (!volets.length) return;

      var actif = -1;
      var attente = false;

      function peindre() {
        attente = false;
        var vh = window.innerHeight;
        var repere = vh * 0.5;          /* le volet au milieu de l'écran gagne */
        var courant = 0;

        for (var i = 0; i < volets.length; i++) {
          var r = volets[i].getBoundingClientRect();
          if (r.top <= repere && r.bottom > repere) { courant = i; }

          /* décalage parallaxe : l'image avance moins vite que la page */
          if (!reduit && medias[i]) {
            var v = parseFloat(medias[i].getAttribute('data-vitesse')) || 0;
            if (v) {
              var centre = r.top + r.height / 2 - vh / 2;
              medias[i].style.transform =
                'translate3d(0,' + (-centre * v).toFixed(1) + 'px,0)';
            }
          }
        }

        if (courant !== actif) {
          actif = courant;
          items.forEach(function (x, n) {
            var on_ = n === courant;
            x.classList.toggle('est-actif', on_);
            x.setAttribute('aria-current', on_ ? 'true' : 'false');
          });
          if (num) num.textContent = courant + 1;
        }
        if (barre && volets.length > 1) {
          var r0 = volets[0].getBoundingClientRect();
          var total = volets.length * vh - vh;
          var fait = Math.min(Math.max(-r0.top, 0), total);
          barre.style.height = (total ? (fait / total) * 100 : 0) + '%';
        }
      }

      function planifier() {
        if (attente) return;
        attente = true;
        requestAnimationFrame(peindre);
      }

      /* Clic : on rejoint le volet correspondant. Si l'entrée est déjà
         active, le second clic ouvre sa collection. */
      items.forEach(function (it, i) {
        on(it, 'click', function () {
          var lien = it.getAttribute('data-lien');
          if (i === actif && lien) { window.location.href = lien; return; }
          var haut = window.scrollY + volets[i].getBoundingClientRect().top;
          window.scrollTo({ top: haut + 4, behavior: 'smooth' });
        });
      });

      on(window, 'scroll', planifier, { passive: true });
      on(window, 'resize', debounce(planifier, 120));
      peindre();
    });
  }

  /* ---------- mur social : fiche ouverte sur place ---------- */
  function initSocial(portee) {
    $$('[data-social]', portee).forEach(function (sec) {
      /* La modale part dans document.body au chargement : on la retrouve
         par son ancrage plutôt que par une recherche dans la section. */
      var modale = sec.__modale ||
                   $('[data-social-modale]', sec) ||
                   document.querySelector('[data-social-modale]');
      if (!modale) return;
      sec.__modale = modale;

      var fiches = $$('[data-social-fiche]', modale);
      var prec = $('[data-social-precedent]', modale);
      var suiv = $('[data-social-suivant]', modale);
      var rail = $('[data-social-rail]', sec);
      if (!fiches.length) return;

      var index = 0;

      function montrer(i) {
        if (i < 0 || i >= fiches.length) return;
        index = i;
        fiches.forEach(function (f, n) { f.hidden = n !== i; });
        if (prec) prec.disabled = i === 0;
        if (suiv) suiv.disabled = i === fiches.length - 1;
      }

      $$('[data-social-ouvrir]', sec).forEach(function (b) {
        on(b, 'click', function () {
          montrer(parseInt(b.getAttribute('data-social-ouvrir'), 10) || 0);
          Panneaux.ouvrir(modale);
        });
      });

      on(prec, 'click', function () { montrer(index - 1); });
      on(suiv, 'click', function () { montrer(index + 1); });

      on(document, 'keydown', function (e) {
        if (!modale.classList.contains('est-ouvert')) return;
        if (e.key === 'ArrowLeft') montrer(index - 1);
        if (e.key === 'ArrowRight') montrer(index + 1);
      });

      if (rail) {
        var pas = function () { return rail.clientWidth * 0.8; };
        on($('[data-social-prev]', sec), 'click', function () {
          rail.scrollBy({ left: -pas(), behavior: 'smooth' });
        });
        on($('[data-social-next]', sec), 'click', function () {
          rail.scrollBy({ left: pas(), behavior: 'smooth' });
        });
      }

      montrer(0);
    });
  }

  /* ---------- popup différée ---------- */
  function initPopup() {
    var p = $('[data-popup-auto]');
    if (!p || estEditeur) return;
    var cle = 'scf-popup-' + (p.getAttribute('data-popup-cle') || 'defaut');
    try { if (sessionStorage.getItem(cle)) return; } catch (err) { return; }
    var delai = parseInt(p.getAttribute('data-popup-delai'), 10) || 6000;
    setTimeout(function () {
      Panneaux.ouvrir(p);
      try { sessionStorage.setItem(cle, '1'); } catch (err) {}
    }, delai);
  }

  /* ---------- init ---------- */
  function init(portee) {
    extraire();
    initOnglets(portee);
    initGaleries(portee);
    initRails(portee);
    initFormulaireProduit(portee);
    initDefilant(portee);
    initSocial(portee);
    initBascule(portee);
  }

  function demarrer() {
    init(document);
    initEntete();
    initRecherche();
    initFiltres();
    initBascule(document);
    initBarreAchat();
    initPopup();
    Panier.recuperer();
  }

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', demarrer);
  else demarrer();

  /* ---------- éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initEntete();
    initRecherche();
    initDefilant(e.target);
    initSocial(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector('.scf-tiroir,.scf-modale');
    if (p) Panneaux.ouvrir(p);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector('.scf-tiroir,.scf-modale');
    if (p) Panneaux.fermer(p);
  });
})();
